/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { AWSRow } from "../row/AWSRow";
import { BaseUUID, BaseMetaColumn, FilterItem, SortItem } from "namirasoft-core";
import { NSBaseMetaDatabase, NSBaseMetaTable } from "namirasoft-site";
import { NamirasoftBillWatchServer } from "../NamirasoftBillWatchServer";

export class AWSMetaTable extends NSBaseMetaTable<NamirasoftBillWatchServer, AWSRow>
{
    public override columns: {
        id: BaseMetaColumn;
        user_id: BaseMetaColumn;
        workspace_id: BaseMetaColumn;
        credential_id: BaseMetaColumn;
        account_id: BaseMetaColumn;
        topic_id: BaseMetaColumn;
        log_group_id: BaseMetaColumn;
        name: BaseMetaColumn;
        active: BaseMetaColumn;
        show_api_call: BaseMetaColumn;
        show_new_cost: BaseMetaColumn;
        max_api_call_total: BaseMetaColumn;
        max_api_call_per_operation: BaseMetaColumn;
        lookback_periods: BaseMetaColumn;
        dimensions: BaseMetaColumn;
        metrics: BaseMetaColumn;
        description: BaseMetaColumn;
        last_run_status: BaseMetaColumn;
        last_run_at: BaseMetaColumn;
        last_run_anomaly_found: BaseMetaColumn;
        last_run_message: BaseMetaColumn;
        next_run_at: BaseMetaColumn;
        created_at: BaseMetaColumn;
        updated_at: BaseMetaColumn;
    }
    constructor(database: NSBaseMetaDatabase<NamirasoftBillWatchServer>)
    {
        super(database, "aws", "AWS", new BaseUUID("bwt-aws"));
        this.columns = {
            id: new BaseMetaColumn(this, "id", "ID", "String", true),
            user_id: new BaseMetaColumn(this, "user_id", "User ID", "String", true),
            workspace_id: new BaseMetaColumn(this, "workspace_id", "Workspace ID", "String", true),
            credential_id: new BaseMetaColumn(this, "credential_id", "Credential ID", "String", true),
            account_id: new BaseMetaColumn(this, "account_id", "Account ID", "String", true),
            topic_id: new BaseMetaColumn(this, "topic_id", "Topic ID", "String", true),
            log_group_id: new BaseMetaColumn(this, "log_group_id", "Log Group ID", "String", true),
            name: new BaseMetaColumn(this, "name", "Name", "String", true),
            active: new BaseMetaColumn(this, "active", "Active", "Boolean", true),
            show_api_call: new BaseMetaColumn(this, "show_api_call", "Show API Call", "Boolean", true),
            show_new_cost: new BaseMetaColumn(this, "show_new_cost", "Show New Cost", "Boolean", true),
            max_api_call_total: new BaseMetaColumn(this, "max_api_call_total", "Max API Call Total", "Integer", true),
            max_api_call_per_operation: new BaseMetaColumn(this, "max_api_call_per_operation", "Max API Call Per Operation", "Integer", true),
            lookback_periods: new BaseMetaColumn(this, "lookback_periods", "Lookback Periods", "Any", true),
            dimensions: new BaseMetaColumn(this, "dimensions", "Dimensions", "Any", true),
            metrics: new BaseMetaColumn(this, "metrics", "Metrics", "Any", true),
            description: new BaseMetaColumn(this, "description", "Description", "String", false),
            last_run_status: new BaseMetaColumn(this, "last_run_status", "Last Run Status", "Enum", true),
            last_run_at: new BaseMetaColumn(this, "last_run_at", "Last Run At", "DateTime", false),
            last_run_anomaly_found: new BaseMetaColumn(this, "last_run_anomaly_found", "Last Run Anomaly Found", "Boolean", false),
            last_run_message: new BaseMetaColumn(this, "last_run_message", "Last Run Message", "String", false),
            next_run_at: new BaseMetaColumn(this, "next_run_at", "Next Run At", "DateTime", false),
            created_at: new BaseMetaColumn(this, "created_at", "Created At", "DateTime", true),
            updated_at: new BaseMetaColumn(this, "updated_at", "Updated At", "DateTime", true),
        };
        this.back_end.get = async (id: string) =>
        {
            let server = this.database.getServer();
            return await server.aws.Get(id);
        };
        this.back_end.list = async (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]) =>
        {
            let server = this.database.getServer();
            return await server.aws.List(filters, page, size, sorts);
        };
    }
};